var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fields-table-view" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-table",
            {
              staticClass: "table edit",
              attrs: {
                data: _vm.fields,
                "header-cell-style": {
                  background: "rgb(48, 65, 86)",
                  color: "white"
                },
                "cell-style": _vm.getCellClassStyle
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  "class-name": "action",
                  width: "80px",
                  align: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("i", {
                          staticClass: "action-item el-icon-copy-document",
                          on: {
                            click: function($event) {
                              return _vm.onCopyField(scope.row)
                            }
                          }
                        }),
                        _c("i", {
                          staticClass: "action-item el-icon-remove-outline",
                          on: {
                            click: function($event) {
                              return _vm.onRemoveField(scope.row)
                            }
                          }
                        }),
                        _c("i", {
                          staticClass:
                            "action-item el-icon-circle-plus-outline",
                          on: {
                            click: function($event) {
                              return _vm.onAddField(scope.row)
                            }
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("Field Name"), width: "150px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.$t("Field Name"),
                            "suffix-icon": "el-icon-edit"
                          },
                          on: {
                            change: function($event) {
                              return _vm.onNameChange(scope.row)
                            }
                          },
                          model: {
                            value: scope.row.name,
                            callback: function($$v) {
                              _vm.$set(scope.row, "name", $$v)
                            },
                            expression: "scope.row.name"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Selector Type"),
                  width: "150px",
                  align: "center",
                  "class-name": "selector-type"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "button-selector-item",
                            on: {
                              click: function($event) {
                                return _vm.onClickSelectorType(scope.row, "css")
                              }
                            }
                          },
                          [
                            _c(
                              "el-tag",
                              {
                                class: scope.row.css ? "active" : "inactive",
                                attrs: { type: "success" }
                              },
                              [_vm._v(" CSS ")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "button-selector-item",
                            on: {
                              click: function($event) {
                                return _vm.onClickSelectorType(
                                  scope.row,
                                  "xpath"
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "el-tag",
                              {
                                class: scope.row.xpath ? "active" : "inactive",
                                attrs: { type: "primary" }
                              },
                              [_vm._v(" XPath ")]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("Selector"), width: "200px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.css
                          ? [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("CSS / XPath"),
                                  "suffix-icon": "el-icon-edit"
                                },
                                model: {
                                  value: scope.row.css,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "css", $$v)
                                  },
                                  expression: "scope.row.css"
                                }
                              })
                            ]
                          : [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("CSS / XPath"),
                                  "suffix-icon": "el-icon-edit"
                                },
                                model: {
                                  value: scope.row.xpath,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "xpath", $$v)
                                  },
                                  expression: "scope.row.xpath"
                                }
                              })
                            ]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Is Attribute"),
                  width: "150px",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "button-selector-item",
                            on: {
                              click: function($event) {
                                return _vm.onClickIsAttribute(scope.row, false)
                              }
                            }
                          },
                          [
                            _c(
                              "el-tag",
                              {
                                class: !_vm.isShowAttr(scope.row)
                                  ? "active"
                                  : "inactive",
                                attrs: { type: "success" }
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("Text")) + " ")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "button-selector-item",
                            on: {
                              click: function($event) {
                                return _vm.onClickIsAttribute(scope.row, true)
                              }
                            }
                          },
                          [
                            _c(
                              "el-tag",
                              {
                                class: _vm.isShowAttr(scope.row)
                                  ? "active"
                                  : "inactive",
                                attrs: { type: "primary" }
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("Attribute")) + " ")]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("Attribute"), width: "200px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm.isShowAttr(scope.row)
                          ? [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("Attribute"),
                                  "suffix-icon": "el-icon-edit"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.onAttrChange(scope.row)
                                  }
                                },
                                model: {
                                  value: scope.row.attr,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "attr", $$v)
                                  },
                                  expression: "scope.row.attr"
                                }
                              })
                            ]
                          : [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-left": "15px",
                                    color: "lightgrey"
                                  }
                                },
                                [_vm._v(" N/A ")]
                              )
                            ]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("Next Stage"), width: "250px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            class: !scope.row.next_stage ? "disabled" : "",
                            on: {
                              change: function($event) {
                                return _vm.onChangeNextStage(scope.row)
                              }
                            },
                            model: {
                              value: scope.row.next_stage,
                              callback: function($$v) {
                                _vm.$set(scope.row, "next_stage", $$v)
                              },
                              expression: "scope.row.next_stage"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("No Next Stage"),
                                value: ""
                              }
                            }),
                            _vm._l(_vm.filteredStageNames, function(n) {
                              return _c("el-option", {
                                key: n,
                                attrs: { label: n, value: n }
                              })
                            })
                          ],
                          2
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Remark"),
                  width: "auto",
                  "min-width": "120px"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.$t("Remark"),
                            "suffix-icon": "el-icon-edit"
                          },
                          model: {
                            value: scope.row.remark,
                            callback: function($$v) {
                              _vm.$set(scope.row, "remark", $$v)
                            },
                            expression: "scope.row.remark"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }